import ActionIcon from './ActionIcon';
import './ActionIcon.scss';

export default ActionIcon;
